import { Box, Button, HStack, ScrollView, Stack, Text, VStack } from 'native-base';
import React, { useCallback, useContext, useEffect } from 'react';
import { NaturalDisasterConstants } from '../../../constants';
import { NavigationContext } from '../../../contexts';
import { useRequestForbearanceMutation, useUpdateBorrowerImpactedStatusMutation } from '../../../hooks';
import { CommonOfferCard, ToastType } from '../../../containers';
const RequestForbearance = _ref => {
  let {
    metadata
  } = _ref;
  const {
    leadApiParams,
    onComplete,
    logUserEvent,
    logApiEvent,
    review,
    accessToken
  } = useContext(NavigationContext);
  const updateBorrowerImpactedStatus = useUpdateBorrowerImpactedStatusMutation({
    borrowerImpactedApiParams: leadApiParams,
    logApiEvent,
    logUserEvent,
    onComplete,
    accessToken
  });
  const requestForbearance = useRequestForbearanceMutation({
    forbearanceApiParams: leadApiParams,
    onComplete,
    logApiEvent,
    logUserEvent,
    type: 'Natural Disaster',
    accessToken
  });
  const submitReviewCallback = useCallback(() => {
    onComplete({
      message: 'enableHeader',
      toastType: ToastType.DEEPLINK
    });
    const data = Object.values(review).reduce((result, current) => {
      return Object.assign({}, result, current);
    }, {});
    if ((data === null || data === void 0 ? void 0 : data.borrowerImpacted) !== '') {
      updateBorrowerImpactedStatus.mutate(data);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [review]);
  useEffect(() => {
    submitReviewCallback();
  }, [review, submitReviewCallback]);
  const onCLickRequestForbearance = async () => {
    logUserEvent({
      type: 'Natural Disaster',
      action: `DisasterRequestForbearanceClicked`,
      description: `Request Forbearance Button Clicked`
    });
    // if (isCreateCit) {
    let request = {
      taskNumber: '784',
      taskMessage: 'Disaster'
    };
    requestForbearance.mutate(request);
    // } else if (redirectUrl) {
    //   Linking.canOpenURL(redirectUrl).then(async () => {
    //     await Linking.openURL(redirectUrl);
    //   });
    //   onComplete({ message: '', toastType: ToastType.SUCCESS });
    // }
  };

  const RenderCards = useCallback((card, index) => /*#__PURE__*/React.createElement(Box, {
    width: {
      base: undefined,
      sm: undefined,
      md: undefined,
      lg: 646
    },
    key: index,
    mx: {
      base: undefined,
      sm: undefined,
      md: undefined,
      lg: '5'
    },
    mb: "7"
  }, /*#__PURE__*/React.createElement(CommonOfferCard, {
    card: card,
    requestedBy: 'ACP',
    logUserEvent: logUserEvent,
    cardType: card.id
  })), []);
  const RenderBulletedPoints = useCallback(text => {
    return /*#__PURE__*/React.createElement(HStack, {
      space: 2
    }, /*#__PURE__*/React.createElement(Box, {
      size: 1.5,
      rounded: "full",
      bg: "black.200",
      mt: "2"
    }), /*#__PURE__*/React.createElement(Text, {
      alignSelf: "center",
      flex: "1",
      w: "full",
      textAlign: "justify",
      fontSize: "md",
      color: "black.200",
      lineHeight: "lg",
      fontFamily: "body",
      fontWeight: "normal",
      accessibilityLabel: text,
      accessibilityRole: "text"
    }, text));
  }, []);
  return /*#__PURE__*/React.createElement(ScrollView, {
    margin: '4'
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: '2xl',
      md: '3xl',
      lg: '4xl'
    },
    color: 'text.running',
    alignSelf: 'center',
    marginBottom: '4',
    fontFamily: 'body',
    fontWeight: '300',
    testID: NaturalDisasterConstants.REQ_FORBEARANCE_PLAN,
    accessibilityLabel: NaturalDisasterConstants.REQ_FORBEARANCE_PLAN
  }, NaturalDisasterConstants.REQ_FORBEARANCE_PLAN), /*#__PURE__*/React.createElement(VStack, {
    space: "4",
    mb: "4",
    w: {
      lg: 918
    },
    alignSelf: {
      lg: 'center'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    marginBottom: '4',
    fontSize: 'md',
    color: 'black',
    lineHeight: 'lg',
    textAlign: 'justify',
    fontFamily: 'body',
    fontWeight: '400',
    testID: NaturalDisasterConstants.REQ_FORBEARANCE_PLAN_DESCRIPTION,
    accessibilityLabel: NaturalDisasterConstants.REQ_FORBEARANCE_PLAN_DESCRIPTION
  }, NaturalDisasterConstants.REQ_FORBEARANCE_PLAN_DESCRIPTION), [NaturalDisasterConstants.REQ_FORBEARANCE_PLAN_SUB_DESCRIPTION_1, NaturalDisasterConstants.REQ_FORBEARANCE_PLAN_SUB_DESCRIPTION_2, NaturalDisasterConstants.REQ_FORBEARANCE_PLAN_SUB_DESCRIPTION_3].map(RenderBulletedPoints)), /*#__PURE__*/React.createElement(Button, {
    marginBottom: '7',
    padding: '5',
    backgroundColor: 'primary.400',
    onPress: onCLickRequestForbearance,
    _text: {
      fontWeight: '500',
      fontSize: 'lg',
      fontFamily: 'body',
      color: 'white.700'
    },
    testID: NaturalDisasterConstants.REQUEST_A_FORBEARANCE,
    accessibilityLabel: NaturalDisasterConstants.REQUEST_A_FORBEARANCE,
    accessibilityRole: "button",
    alignSelf: 'center',
    isLoading: requestForbearance.isLoading,
    isLoadingText: NaturalDisasterConstants.REQUEST_A_FORBEARANCE,
    _loading: {
      bg: 'primary.400:alpha.70',
      _text: {
        color: 'coolGray.50'
      }
    },
    _spinner: {
      color: '#ffffff'
    },
    spinnerPlacement: "end"
  }, NaturalDisasterConstants.REQUEST_A_FORBEARANCE), /*#__PURE__*/React.createElement(Stack, {
    display: "flex",
    flexWrap: "wrap",
    direction: {
      base: 'column',
      sm: 'column',
      md: 'column',
      lg: 'row'
    },
    justifyContent: "center"
  }, metadata.map(RenderCards)));
};
export default /*#__PURE__*/React.memo(RequestForbearance);
//# sourceMappingURL=index.js.map